import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=a8b7bbb2&scoped=true"
import script from "./OrderComponent.vue?vue&type=script&lang=js"
export * from "./OrderComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&id=a8b7bbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b7bbb2",
  null
  
)

export default component.exports